import { getGtmContentGroup } from '~/utils/getGtmContentGroup'
import { useIsSubdomain } from '~/composables/useSubdomain'

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return

  const {
    public: { baseUrl },
  } = useRuntimeConfig()
  const gtm = useKftGtm()
  const excludedRoutes = ['/embedded/', '/ping/', '/widgets/']
  const { isEmbedded } = useEmbeddedCheckout()
  const isSubdomain = useIsSubdomain()

  const shouldEnableGtm =
    gtm &&
    gtm.enable &&
    !isEmbedded.value &&
    !excludedRoutes.some((x) => to.path.match(x)) &&
    !isSubdomain.value

  if (!shouldEnableGtm) return

  gtm.enable()

  // Changed from: if (to.path === from.path) return
  // Only skip if we're genuinely staying on the same page (not initial load)
  if (from.name && to.path === from.path) return

  setTimeout(() => {
    gtm.pushToDataLayer({
      routeName: to.name,
      content_group: getGtmContentGroup(to),
      pageType: 'PageView',
      pageUrl: baseUrl + to.fullPath,
      pagePath: to.fullPath,
      pageTitle: document?.title || '',
      event: 'nuxtRoute',
    })
  }, 2000)
})
